@import 'styles/mixins';
@import 'styles/variables';

.loaderContainer {
  display: flex;
  justify-content: center;
  max-width: 816px;
}

.loader {
  animation: spin 2s linear infinite;
  border: 2px solid $gray-10;
  border-top: 2px solid var(--focus-50);
  border-radius: 50%;
  height: 24px;
  width: 24px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
